import { defineComponent as _defineComponent } from 'vue'
import {
  InteractionWithNFT,
  Offer,
} from '@/composables/collectionActivity/types'
import EventRowDesktop from './eventRow/EventRowDesktop.vue'
import EventRowTablet from './eventRow/EventRowTablet.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventRow',
  props: {
    event: null,
    variant: null
  },
  setup(__props: any) {



return { __sfc: true,EventRowDesktop, EventRowTablet }
}

})